<template>
  <div class="">
    <div class="class-date flex flex-center">
      <van-icon name="arrow-left" @click="prevArrow" />
      <span @click="selectDate">{{ date }}</span>
      <van-icon name="arrow" @click="nextArrow" />
    </div>
    <div class="attendance">
      <div class="student-attendance student-attendance-1" v-show="!checked">
        <div class="title flex flex-b flex-vc">
          <span>入校统计</span>
          <div class="flex flex-vc">
            <van-switch v-model="checked" />
            <span class="c666">离校统计</span>
          </div>
        </div>
        <div class="attendance-count-chart flex flex-b">
          <canvas id="chart" class="chart"></canvas>

          <div class="count flex flex-dc flex-a">
            <div class="count-item flex">
              <div class="yuan"></div>
              <div class="info">总人数</div>
              <div class="num">{{ data2.classNumber }}人</div>
            </div>

            <div class="count-item flex flex-vc">
              <div class="yuan qian"></div>
              <div class="info">已签到</div>
              <div class="num">{{ data2.normalNumber }}人</div>
            </div>
            <div class="count-item flex flex-vc">
              <div class="yuan que"></div>
              <div class="info">缺勤</div>
              <div class="num quec">{{ data2.absenceNumber }}人</div>
            </div>
            <hr style="background-color: #ececec; height: 1px; border: none" />
            <div class="count-item flex flex-vc">
              <div class="yuan qing"></div>
              <div class="info">请假</div>
              <div class="num">{{ data2.leaveNumber }}人</div>
            </div>
          </div>
        </div>
      </div>
      <div class="student-attendance student-attendance-1" v-show="checked">
        <div class="title flex flex-b flex-vc">
          <span>离校统计</span>
          <div class="flex flex-vc">
            <van-switch v-model="checked" />
            <span class="c666">离校统计</span>
          </div>
        </div>
        <div class="ss-info">
          <div class="info-item">
            <div class="info-count">
              <span>{{ data2.normalNumber || 0 }}</span>
              <span class="unit">人</span>
            </div>
            <div class="info-name">入校人数</div>
          </div>
          <div class="info-item">
            <div class="info-count">
              <span>{{ data2.notInSchoolNumber || 0 }}</span>
              <span class="unit">人</span>
            </div>
            <div class="info-name">离校人数</div>
          </div>
          <div class="info-item">
            <div class="info-count">
              <span style="color: #d21111">{{
                data2.inSchoolNumber || 0
              }}</span>
              <span class="unit">人</span>
            </div>
            <div class="info-name">留校人数</div>
          </div>
        </div>
      </div>
      <div class="student-attendance student-attendance-2" style="padding-bottom: 0.45rem;">
        <div class="title flex flex-b flex-vc">
          <span>班级出勤率</span>
          <div class="flex flex-vc">
            <span class="c37a" @click="linkPath(0)">查看详情 ></span>
          </div>
        </div>
        <div class="class-list">
          <div
            class="class-item flex flex-vc"
            v-for="item in ratelist"
            :key="item.id"
            @click="linkPath(item.id)"
          >
            <div class="name">{{ item.className }}</div>
            <van-progress
              :percentage="item.attendanceRate"
              :show-pivot="false"
              stroke-width="8"
              class="flex-1 progress"
              color="linear-gradient(360deg, #76D1FF 0%, #0D93D5 100%)"
            />
            <div class="percentage">{{ item.attendanceRate }}%</div>
          </div>
        </div>
      </div>
      <div class="student-ranking">
        <div class="title flex flex-b flex-vc">考勤榜单</div>
        <div class="ranking">
          <div class="item" @click="hrefOtherPage('/studentAttendanceList')">
            <img :src="img1" alt="" />
            <p>全勤榜</p>
          </div>
          <div class="item" @click="hrefOtherPage('/studentAbsenceList')">
            <img :src="img2" alt="" />
            <p>缺勤榜</p>
          </div>
        </div>
      </div>
    </div>
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      type="date"
      :currentDate="startMinTime"
    />
  </div>
</template>

<script>
import F2 from "@antv/f2/lib/index-all";
import SelectTime from "@/components/subScribePopup/selectTime";
import moment from "moment";
// import assign from "@/mixins/assign";
import img1 from "@/assets/images/全勤.png";
import img2 from "@/assets/images/缺勤.png";

export default {
  // mixins: [assign],
  data() {
    return {
      checked: false,
      data: {
        attendance: 1,
        normal: 20,
        normal: 30,
        leaveNumber: 30,
      },
      data2: {},
      chart: null,
      date: moment().format("YYYY-MM-DD"),
      startMinTime: new Date(moment().format("YYYY-MM-DD")),
      minDate: new Date(2020, 1, 1),
      ratelist: [],
      guide: null,
      img1,
      img2,
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.renderBase()
    // })
    this.getInfo();
    this.getRate();
  },
  components: {
    SelectTime,
  },
  methods: {
    async getRate() {
      const { data, code } = await this.$https.getClassInfo({
        schoolId: this.$store.state.schoolId,
        toDay: this.date,
      });
      if (code !== 200) {
        return false;
      }
      this.ratelist = data;
    },
    async getInfo() {
      const { data, code } = await this.$https.getLeaveStudentDataByschoolId({
        schoolId: this.$store.state.schoolId,
        toDay: this.date,
      });
      if (code !== 200) {
        return false;
      }
      const d = data[0];
      let dat = [
        {
          name: "已签到",
          percent: d.normalNumber,
          a: "1",
        },
        {
          name: "缺勤",
          percent: d.absenceNumber,
          a: "1",
        },
      ];
      const rate = ((d.normalNumber / d.classNumber) * 100).toFixed(2);
      this.data2 = d;

      this.$nextTick(() => {
        if (this.guide) {
          this.guide.remove();
        }
        this.renderBase(dat, rate);
      });
    },
    selectDate() {
      this.$refs.starttime.showTimePopup = true;
    },
    handleTimeStartConfirm(v) {
      this.date = v;
      this.getInfo();
      this.getRate();
    },
    renderBase(data, rate) {
      this.chart = new F2.Chart({
        id: "chart",
        pixelRatio: window.devicePixelRatio,
        padding: [5, 5],
      });
      this.chart.source(data);
      this.chart.tooltip(false);
      this.chart.legend(false);
      this.chart.coord("polar", {
        transposed: true,
        innerRadius: 0.7,
        radius: 1,
      });
      this.chart.axis(false);
      this.chart
        .interval()
        .position("a*percent")
        .color("name", ["#76D1FF", "#FF738F"])
        .adjust("stack");
      this.guide = this.chart.guide().html({
        position: ["50%", "53%"],
        html: `<div style="width: 250px;height: 40px;text-align: center;">
              <div style="font-size: 1.0625rem;color:#A9AAB0;" id="dddddd">${rate}%</div>
              <div style="font-size: 0.8125rem;color:#A9AAB0;" id="aaaaaa">出勤率</div>
            </div>`,
      });
      this.chart.render();
    },
    linkPath(id) {
      this.$router.push(`./singleClasses?id=${id}&date=${this.date}`);
    },
    prevArrow() {
      this.date = moment(this.date).subtract(1, "days").format("YYYY-MM-DD");
      this.startMinTime = new Date(
        moment(this.date).subtract(1, "days").format("YYYY-MM-DD")
      );
    },
    nextArrow() {
      this.date = moment(this.date).add(1, "days").format("YYYY-MM-DD");
      this.startMinTime = new Date(
        moment(this.date).add(1, "days").format("YYYY-MM-DD")
      );
    },
    hrefOtherPage(url) {
      this.$router.push(url + "?appId=wx196a8663a913cfe0");
    },
  },
  watch: {
    date() {
      this.getInfo();
      this.getRate();
    },
  },
};
</script>

<style>
.van-switch {
  width: 50px;
  height: 20px;
  margin-right: 6px;
  background: rgb(147, 148, 143);
}
.van-switch--on {
  background: #1989fa;
}
.van-switch__node {
  width: 20px;
  height: 20px;
}
</style>
<style lang="scss" scoped>
.class-date {
  padding: 15px 0;
  span {
    margin: 0 20px;
    font-size: 15px;
    color: #1a1a1a;
  }
}
.title {
  padding: 12px 25px;
  position: relative;
  font-size: 15px;
  color: #1a1a1a;

  &::before {
    content: "";
    position: absolute;
    left: 15px;
    height: 13px;
    width: 3px;
    background: #37a5da;
    top: 16px;
  }
}
.attendance {
  padding: 0 15px 30px;
}
.c666 {
  color: #666666;
  font-size: 13px;
}
.c37a {
  color: #37a5da;
}
.student-attendance {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
}
.student-attendance-1 {
  .attendance-count-chart {
    padding: 27px;
    .chart {
      width: 135px;
      height: 135px;
      /* border: 1px solid #37a5da; */
    }
    .count {
      // margin-left: 40px;
      &-item {
        font-size: 13px;
        .yuan {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          &.qian {
            background: #76d1ff;
          }
          &.qing {
            background: #f0c81e;
          }
          &.que {
            background: #ff738f;
          }
        }
        .quec {
          color: #ff738f;
        }
        .info {
          display: inline-block;
          min-width: 40px;
          color: #666666;
          margin: 0 16px 0 6px;
        }
      }
    }
  }
}
.student-attendance-2 {
  .class-list {
    .class-item {
      padding: 8px 15px 8px 23px;
      font-size: 13px;
      color: #666666;
      // .name {
      //   width: 60px;
      // }
      // //大于4个，小于8个字
      // .name.sm{
      //   width:5.75rem
      // }
      // // 大于等于8个字
      // .name.medium{
      //   width:7.75rem;
      // }
      // .name.large{

      // }
      .progress {
        margin-left: 10px;
        margin-right: 15px;
      }
      .percentage {
        /* color: #48b6ed; */
        font-size: 12px;
      }
    }
  }
}

.ss-info {
  display: flex;
  background: #fff;
  /* box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08); */
  border-radius: 1rem;
  padding: 1rem 0;
  /* margin-top: 1rem; */
  justify-content: center;
  .info-item {
    flex: 1;
    text-align: center;
    border-right: 0.06rem solid #f4f4f6;
    &:last-child {
      border-right: none;
    }
    .info-count {
      font-size: 1.25rem;

      color: #454f63;
      .unit {
        font-size: 0.69rem;
        color: #78849e;
        margin-left: 0.4rem;
      }
    }
    .info-name {
      color: #78849e;
      font-size: 0.69rem;
      margin-top: 0.3rem;
    }
  }
}
.student-ranking {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  .ranking {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 3% 12% 5%;
    .item {
      img {
        width: 72px;
        height: 72px;
      }
      p {
        text-align: center;
        font-size: 14px;
      }
    }
  }
}
</style>
